import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { environment } from '@ib-env/environment';
import { IBalancesResponse } from '@ib-shared/interfaces/balances-response.intf';
import { Observable, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class BalancesHttpService {
  constructor(private http: HttpClient) {}

  public fetchBalances(): Observable<IBalancesResponse> {
    const mock = of({
      balance: {
        // EUR: 1,
        // USD: 1023.123123,
        // GBP: 234234234.2323,

        EUR: 0,
        USD: 0,
        GBP: 0,
      },
      yield: 23423.43,
    });
    return environment.production
      ? this.http.get<IBalancesResponse>(
          `${environment.apiUrl}/api/investorbalance`,
        )
      : mock;
  }

  public increaseBalance(amount: number): Observable<boolean> {
    return this.http.post<boolean>(
      `${environment.apiUrl}/api/investor/increase-balance`,
      { amount },
    );
  }
}
